<template>
  <table v-if="allOptions.length" class="table table-striped">
    <thead>
      <tr>
        <th>Option</th>
        <th>Swahili</th>
        <th>Next Stage</th>
        <th>Next Apps</th>
        <th>Disable/Enable</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(eachOption, index) in allOptions" :key="index">
        <td>{{eachOption.eng}}</td>
        <td>{{eachOption.swa}}</td>
        <td>{{eachOption.nextStage}}</td>
        <td>{{eachOption.nextApps}}</td>
        <td><switch-button v-model="eachOption.enabled"></switch-button></td>
        <td v-if="!eachOption._id"><i class="fa fa-times-circle" v-on:click="removeOption(index)" aria-hidden="true"></i></td>
        <td v-if="eachOption._id"><i class="fa fa-pencil" v-on:click="editOption(index)" aria-hidden="true"></i></td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import SwitchButton from './switch-button'

export default {
  name: 'alloptions',
  components: {
    'switch-button': SwitchButton
  },
  computed: mapState({
    allOptions: state => state.menu.menuOptions
  }),
  methods: {
    /**
     * @description emit an event to edit the clicked option
     * @param {number} index - the index of the option in the menuOptions array in the store
     */
    editOption (index) {
      this.$emit('edit', index)
    },
    ...mapActions(['removeOption'])
  }
}
</script>



// WEBPACK FOOTER //
// allOptions.vue?70c54f01